@use "../../styles/breakpoint.module.scss" as *;

.layout {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    row-gap: var(--spacer-24);

    .carouselArea {
        grid-column: 1 / -1;
    }

    &:has([data-carousel-all-visible="true"]) {
        .carouselArea {
            margin-right: 0;
        }

        .scrollContainer {
            text-align: center;
        }

        .slideItem:last-child {
            margin-right: 0;
        }

        .slideItem {
            text-align: initial;
        }
    }

    // With a left-aligned header on desktop, keep cards left, not centered.
    &[data-alignment="left"]:has([data-carousel-all-visible="true"]) {
        @media ($above-tablet) {
            .scrollContainer {
                text-align: left;
            }
        }
    }
}

.headingArea {
    grid-column: 1 / -1;
}

.header {
    @media ($below-tablet) {
        text-align: center;
    }
}

.ctaDesktop {
    @media ($below-tablet) {
        display: none;
    }
}

.ctaMobile {
    grid-column: 1 / -1;
    align-items: center;

    @media ($above-tablet) {
        display: none;
    }
}

[data-alignment="center"] .header {
    text-align: center;
}

// Restore the gap a single RichTextStreamBlock would put before the CTA;
// Add some margin to the bottom at design's request
[data-alignment="center"] .ctaDesktop {
    margin-block: var(--spacer-16) var(--spacer-8);
}

// Left, on desktop: prose and CTA share the top row via a 2-column grid.
// The CTA column sizes to its own width
[data-alignment="left"] {
    @media ($above-tablet) {
        .headingArea {
            display: grid;
            grid-template-columns: 1fr auto;
            align-items: end;
            column-gap: var(--spacer-24);
        }
    }

    // stylistic one-off
    .header {
        gap: var(--spacer-4);
    }
}

.carouselArea {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--spacer-24);
    margin-right: calc(-1 * var(--labui-container-margin));
    overflow: hidden;
}

.slidesWrapper {
    --slides-visible: var(--slides-visible-desktop);
    --scrolls: var(--scrolls-desktop);
    --gutters: calc(var(--slides-visible) - 1);
    --gutter-width: var(--spacer-24);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--slides-visible));

    @media ($below-tablet) {
        --slides-visible: var(--slides-visible-tablet);
        --scrolls: var(--scrolls-tablet);
    }

    @media ($below-mobile) {
        --slides-visible: var(--slides-visible-mobile);
        --scrolls: var(--scrolls-mobile);
    }
}

.slideItem {
    width: var(--width);
    flex-shrink: 0;
    margin-right: var(--gutter-width);

    // Inset the last card from the viewport edge, but only at breakpoints where
    // the carousel scrolls (--scrolls is 0 where slides fit) so it never adds
    // phantom overflow that would latch the all-visible detection.
    &:last-child {
        margin-right: calc(var(--scrolls, 0) * var(--labui-container-margin));
    }
}

.arrows {
    inset: 0 var(--labui-container-margin) 0 0;
    z-index: 3;

    @media ($below-mobile) {
        display: none;
    }
}

.dots {
    position: static;
    transform: none;
    justify-content: center;
}
